import { Typography } from "@packages/ds";
import styled from "styled-components";

import * as R from "../ResourceRow/ResourceRow.style";

export const TotalWrapper = styled(R.ResourceRow)`
  border-radius: 8px;
  padding: 16px 0;
  margin-top: 36px;
  margin-bottom: 20px;
  background-color: var(
    --section-color-primary-100-background-color,
    var(--color-primary-100)
  );

  & > :last-child {
    padding-right: 16px;
  }
  @media (max-width: 720px) {
    display: none;
  }
`;

export const TotalTitle = styled(Typography.BodyText)`
  padding-left: 16px;
`;

export const TotalMobileWrapper = styled.div`
  display: none;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, max-content);
  row-gap: 16px;
  margin: 40px auto 32px auto;

  & > :nth-child(1) {
    grid-column: 1 / 3;
  }

  @media (max-width: 720px) {
    display: grid;
  }
`;

export const TotalTypeLabel = styled(Typography.Label)`
  color: var(--label-granite-color, var(--granite));
`;
